import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const variantClasses = {
  blue: 'bg-cs-navy-600 text-white',
  orange: 'bg-cs-orange-75 text-cs-gray-900'
};

ProjectDescriptionTag.propTypes = {
  variant: PropTypes.oneOf(Object.keys(variantClasses)),
  children: PropTypes.node
};

export default function ProjectDescriptionTag(props) {
  const { variant = 'blue', children } = props;

  const colorClass = variantClasses[variant] ?? variantClasses.blue;

  return (
    <span className={classNames(
      `inline-flex items-center justify-center
       font-medium text-base leading-[22px]
       px-[15px] py-[5px] rounded-full
       whitespace-nowrap select-none`,
      colorClass
    )}>
      {children}
    </span>
  );
}
